import { Box } from "@mui/material";
import GroupA from "@src/ruix/components/atoms/groups/GroupA";
import Empty from "@src/ruix/components/atoms/layouts/Empty";
import StepPaperA from "@src/ruix/components/atoms/papers/StepPaperA";
import { ExpertStepBoxProps } from "@src/ruix/types";
import ExpertCardItem from "./ExpertCardItem";
import TitleWithNumbers from "./TitleWithNumbers";

const ExpertStepBox = (props: ExpertStepBoxProps) => {
	const { cardData, stepData, headerAction } = props;

	const step = stepData.number;

	const getStepData = (st: number) => {
		switch (st) {
			case 1:
				return "step1";
			case 2:
				return "step2";
			case 3:
			default:
				return "step3";
		}
	};

	return (
		<StepPaperA borderColor={getStepData(step)}>
			<Empty space={20} />
			<Box
				sx={{
					display: "flex",
					alignItems: "flex-start",
					justifyContent: "space-between",
					width: "100%",
					gap: 1.2,
				}}
			>
				<TitleWithNumbers {...stepData} />
				{headerAction ? (
					<Box sx={{ flexShrink: 0, marginLeft: "auto" }}>{headerAction}</Box>
				) : null}
			</Box>
			<Empty space={30} />
			<GroupA fullWidth order="column-start-start" gap={20}>
				{cardData.map((card, index) => (
					<ExpertCardItem key={`ExpertStepBoxExpertCardItem${index}`} {...card} />
				))}
			</GroupA>
		</StepPaperA>
	);
};

export default ExpertStepBox;
